
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from './elements/CustomButton/CustomButton';
import { useNavigate } from 'react-router-dom';

function LogoutConfirmation({ onClose }) {
      const { loginDetails } = useSelector((state) => state.counter);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch({ type: 'RESET_STORE' });

        navigate('/');
    }
    return (
        <div className="pt-6 px-10" >
            <div className="flex justify-center w-full text-xl font-[600]" >Logout Confirmation</div>
            <div className='flex flex-col my-4 w-full justify-center items-center' >
                <div className='mb-6 py-2 text-center'>Are you sure you’d like to log out of your account?</div>
                <div className='flex flex-col xs:flex-row justify-center items-center mb-4 gap-3'>
                    <CustomButton
                        onClick={onClose}
                        customeClass={` w-[130px] h-[40px] ${loginDetails?.userType === "normal user" ? "customer-light-button" : "primary-custom-button"}`}

                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        onClick={() => handleLogout()}
                        customeClass={` w-[130px] h-[40px] ${loginDetails?.userType === "normal user" ? "customer-dark-button" : "gradient-button"}`}
                    >
                        Sign Out
                    </CustomButton>
                </div>
            </div>
        </div>
    );
}

export default LogoutConfirmation;